import { notification } from '@/plugins/helpers'
import { AlertTypes } from '../plugins/alerts_types'
import { BranchMessages } from '../enums/branch/messages'

export default {
  data () {
    return {
      filiais_visiveis: []
    }
  },
  methods: {
    async loadFiliais (retries = 3, delay = 1000) {
      try {
        const response = await this.$http.get('/filiais/ponto_venda', {
          params: {
            id_ponto_venda: this.$session.get('id_ponto_venda'),
            id_empresa: this.$session.get('id_empresa')
          }
        })
        this.filiais_visiveis = Array.isArray(response.data.Filiais.Filial) && response.data.Filiais.Filial.length > 0
          ? response.data.Filiais.Filial
          : []

        if (this.filiais_visiveis.length === 0) {
          notification(AlertTypes.ERROR, BranchMessages.ERROR_EMPTY_BRANCHES)
        }
      } catch (err) {
        if (retries > 0) {
          return this.loadFiliais(retries - 1, delay)
        }
        const textoAdicional = err?.response?.data?.Msg_Erro ? 'Indique o seguinte erro para a Área de Suporte: ' + err.response.data.Msg_Erro : 'entre em contato com a Área de Suporte.'
        notification(AlertTypes.ERROR, `${BranchMessages.ERROR_LOADING_BRANCHES} ${textoAdicional}`)
      }
    }

  }
}
